import * as React from 'react';
import { Header2 } from '../NavBar/Header2';
import Footer from '../Footer/Footer';
import Preparations from './Preparations';
import Protocol from './Protocol';
import Stages from './Stages';
import Recruitment from './Recruitment';
import Reporting from './Reporting';
import Technology from './Technology';
import AfterDC from './AfterDC';
import './MemberFAQ.css';
import '../../App.css';
import Temp from './Temp';

const MemberFAQ = () => {

    return (
        <>
            <Header2 />
            <div className='things_to_know' style={{ marginBottom: '3rem' }}>
                <h1 style={{ color: '#494b4d', textAlign: 'center', width: '100%' }}>Important things to know</h1><br/>
                <Preparations/>
                <Protocol/>
                <Stages/>
                <Recruitment/>
                <Reporting/>
                <Technology/>
                <AfterDC/>
                {/* <Temp/> */}
            </div>
            <Footer />
        </>
    );
}

export default MemberFAQ;